import { render, staticRenderFns } from "./InboundOverview.vue?vue&type=template&id=3e192b34&scoped=true&"
import script from "./InboundOverview.vue?vue&type=script&lang=js&"
export * from "./InboundOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e192b34",
  null
  
)

export default component.exports